import React from 'react';
import { useRecoilValue } from 'recoil';
import { productPackStepOptionState } from '../../../../utils/recoil/product';

export const Progress = ({ color, index }) => {
  const productPackStepOption = useRecoilValue(productPackStepOptionState);
  const ratio = productPackStepOption[index] === 2 ? 85 : 15;

  return (
    <div className='w-full bg-gray-200 h-1'>
      <div
        className={`bg-${
          color?.classname || 'primary'
        } h-1 transform ease-in-out duration-300`}
        style={{ width: `${ratio}%` }}
      />
    </div>
  );
};
